<template>
    <div class="button-group">
        <button class="btn btn-success" @click="search"><i class="cil-search"> </i> Cari</button>
        <button class="btn btn-warning" @click="reset"><i class="cil-reload"> </i> Reset</button>
    </div>
</template>

<script>
    export default {
        name: "CRButton",
        methods: {
            search(evt) {
                this.$emit('onSearch', evt);
            },
            reset(evt) {
                this.$emit('onReset', evt);
            }
        }
    }
</script>
